import { createFileRoute } from "@tanstack/react-router";
import { OnboardingStatusPage } from "@/features/dashboard/pages/onboarding-status";

export const Route = createFileRoute("/(app)/dashboard/onboarding-status")({
  component: () => <OnboardingStatusPage />,
});
